import { FC } from "react";
import { Box } from "@mui/material";
import { footerHeight } from "../../NavBars/Footer/hardCodeData";
import CarCard from "./Components/CarCard";
import { headerHeight } from "../../NavBars/Header/hardCodeData";
import { carModelsMain } from "./hardCodeData";
import TechnologyGreenFuture from "./Components/TechnologyGreenFuture";
import TestDriveAndContactUs from "./Components/TestDriveAndContactUs";
import "./style.css";

const Main: FC = () => {
  return (
    <Box
      sx={{
        minHeight: `calc(100vh - ${footerHeight})`,
        pt: headerHeight,
      }}
    >
      {carModelsMain.map((car, i) => {
        return (
          <CarCard
            key={i}
            id={car.id}
            name={car.name}
            Img={car.img}
            ImgMob={car.img_mob}
          />
        );
      })}
      <TestDriveAndContactUs />
      <TechnologyGreenFuture />
    </Box>
  );
};

export default Main;
